<script>
  export let onClick
</script>

<button on:click={onClick} class="menu-bar-menu-dialog-button">
  <slot />
</button>

<style>
  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    appearance: none;
  }
  .menu-bar-menu-dialog-button {
    color: #184398;
    height: 50px;
  }
  .menu-bar-menu-dialog-button:hover {
    cursor: pointer;
    background-color: #f3f3f3;
  }
</style>